import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import logo from './img/logo.svg'
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-thundernet-container text-align-center" ref={nodeRef}>
        <div className="login-thundernet-header" style={{ marginBottom: '40px' }}>
          <img src={logo} alt="logo" className="logo-thundernet rounded mx-auto d-block" />
        </div>
        <div>
          <p className="signInHeader">{translate("SignIn")}</p>
        </div>
        <div className="login-thundernet-body">
          <Form className="thundernet-form" onSubmit={event => onSubmit(event)}>
            <Col sm="12" xs="12" md="12" style={{ padding: '0px', textAlign: 'left' }}>
              <label>{translate("email")}</label>
              <Input
                className="input-thundernet"
                disabled={onLogin}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                id="username"
                onChange={e => setUsername(e.target.value)}
              />
            </Col>
            <Col sm="12" xs="12" md="12" style={{ padding: '0px', textAlign: 'left' }}>
              <label>{translate("Senha")}</label>
              <Input
                className="input-thundernet"
                required={true}
                disabled={onLogin}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password"
                onChange={e => setPassword(e.target.value)}
              />
            </Col>
            {!onLogin ?
              <div className="row thundernet-btns-row">
                <div className="col-xs-12 col-md-12 col-lg-12">
                  <div>
                    <button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      className="enter-thundernet"
                      type="submit"
                      name="submit"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                </div>
              </div>
              :
              <Progress animated color="danger" value={100} />
            }
            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                {error.message}
              </Alert>
            </div>
          </Form>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm);
